import { render } from "./Start.vue?vue&type=template&id=98ccc676&bindings={}"
import script from "./Start.vue?vue&type=script&lang=js"
export * from "./Start.vue?vue&type=script&lang=js"

import "./Start.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script